import type { DerivedWorkflowData } from '.';

export const _deriveWorkflowData = (
  workflowConfig: any
): DerivedWorkflowData => {
  return {
    published: workflowConfig.published === true ? true : false,
  };
};
